import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";

@Component
export default class Reading extends Vue {
  @Prop({ default: null }) data: any; // data to inject into chart

  private refId = "balaReading";
  private chartId = "bala-reading";
  private chartSelections: string[] = [];

  private selection: string = "";
  private descriptions: any; // dashboard descriptions

  private data_unf: any; // processed chart specific data

  private chartData = {
    type: "horizontalBar",
    labels: [],
    data: { labels: [], datasets: [] },
    options: {
      responsive: true,
      barValueSpacing: 20,
      lineTension: 1,
      // title: {
      // display: true,
      // text: 'RIP',
      // },
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            id: "y-axis-0",
            scaleLabel: {
              display: false,
              labelString: "Criterion"
            },
            ticks: {
              beginAtZero: true,
              padding: 25
            }
          }
        ],
        xAxes: [
          {
            id: "x-axis-0",
            scaleLabel: {
              display: true,
              labelString: "Percentage of Questions Answered Correctly (%)"
            },
            ticks: {
              beginAtZero: true,
              suggestedMax: 100
            }
          }
        ]
      },
      annotation: {
        annotations: []
      }
    }
  };

  created() {
    this.descriptions = this.$store.getters.studentDashboard.bala.descriptions;
    this.chartSelections = Object.keys(this.descriptions.dashboards);
    this.selection = this.chartSelections[0];
    this.data_unf = this.getDataset(this.data);
  }

  private boxAnnotation(averages: any, labels: string[]) {
    let axisToYbounds: any = {};
    labels.forEach((label, i) => {
      axisToYbounds[label] = [i - 0.4, i + 0.4];
    });

    let annotations: any = [];
    labels.forEach((item: any, i) => {
      annotations.push({
        backgroundColor: "black",
        mode: "vertical",
        type: "box",
        value: 1,
        xScaleID: "x-axis-0",
        yScaleID: "y-axis-0",
        xMin: averages[i] - 0.3,
        xMax: averages[i],
        yMin: axisToYbounds[item][0],
        yMax: axisToYbounds[item][1]
      });
    });
    return annotations;
  }

  private getDataset(data: any) {
    let labels: any = [];
    let averages: any = [];
    let score: any = [];
    let backgroundColor: any = [];

    let dashboard = this.descriptions.dashboards[this.selection];

    Object.keys(dashboard.datapoints).forEach(key => {
      let label = dashboard.datapoints[key].label;
      let _score = data[key] !== undefined ? data[key].percent : undefined;
      let _averages = data[key] !== undefined ? data[key].mean : undefined;
      let color = dashboard.datapoints[key].color;

      if (_score != undefined) {
        labels.push(label);
        score.push(_score);
        averages.push(_averages);
        backgroundColor.push(color);
      }
    });

    let dataset = [
      {
        // there's going to be 5 reading tasks
        backgroundColor: backgroundColor,
        data: score
      }
    ];

    return {
      labels: labels,
      score: score,
      dataset: dataset,
      averages: averages,
      color: backgroundColor
    };
  }

  mounted() {
    this.updateChart();
  }

  private updateChart() {
    this.data_unf = this.getDataset(this.data);
    let data = this.data_unf;

    if (data.averages)
      (this.chartData.options.annotation
        .annotations as any) = this.boxAnnotation(data.averages, data.labels);

    (this.chartData.data.datasets as any) = data.dataset;
    (this.chartData.data.labels as any) = data.labels;
    (this.$refs[this.refId] as any).forceRefresh();
  }

  render(h: CreateElement) {
    return (
      <v-card>
        {/* <v-toolbar></v-toolbar> */}
        <v-card-title
          class="mx-auto text-center"
          style={{ paddingTop: "0", paddingBottom: "0" }}
        >
          Your Reading Performance
          <v-row dense>
            <v-col cols="6"></v-col>
            <v-col cols="6">
              <v-select
                items={this.chartSelections}
                v-model={this.selection}
                onChange={() => {
                  this.updateChart();
                }}
              ></v-select>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <p>
            The coloured bars show your performance. The black lines show your
            class' average.
          </p>
          <ChartTypes
            chartId={this.chartId}
            chartData={this.chartData}
            ref={this.refId}
          ></ChartTypes>
          <br />
          {this.averagesText()}
        </v-card-text>
      </v-card>
    );
  }

  private averagesText() {
    let data = this.data_unf;
    return (
      <p>
        Class Averages: &nbsp;
        {data &&
          data.labels.map((item: string, i: number) => (
            <span>
              <b>
                <span style={{ color: data.color[i] }}>{item}</span>:{" "}
              </b>
              <span>
                {data.averages[i]}%{i != data.labels.length - 1 ? "," : ""}{" "}
                &nbsp;
              </span>
            </span>
          ))}
      </p>
    );
  }
}

const component = Reading;
